import store from 'javascripts/store.js';

const AmountButtonsExperiment = {
  showAmountInputExperiment: function(showAmountInput = false) {
    store.donateForm.showAmountInputExperiment = showAmountInput;
  },

  setProductVariant: function(product = 'one-time-and-monthly') {
    store.donateForm.productVariant = product;
  },

  setOptimizelyParams: function(params = {}) {
    store.donateForm.optimizelyParams = params;
  },
};

export default AmountButtonsExperiment;
